var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 243,
    viewBox: "0 0 242 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:heart-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.8449 16.2C53.0193 16.1992 40.4814 20.0335 29.817 27.2178C19.1526 34.4022 10.8406 44.6139 5.93237 56.5616C1.02409 68.5093 -0.260064 81.6563 2.24231 94.3399C4.74468 107.023 10.9212 118.674 19.9907 127.818L115.812 224.435C116.559 225.189 117.445 225.788 118.421 226.196C119.397 226.604 120.443 226.814 121.5 226.814C122.557 226.814 123.603 226.604 124.579 226.196C125.555 225.788 126.441 225.189 127.187 224.435L223.009 127.802C234.841 115.474 241.394 98.9515 241.255 81.7969C241.115 64.6423 234.295 48.2301 222.264 36.0996C210.233 23.969 193.956 17.092 176.943 16.9515C159.929 16.811 143.543 23.4182 131.317 35.3484L121.5 45.2304L111.699 35.3484C105.675 29.2752 98.524 24.4582 90.6535 21.1727C82.7829 17.8871 74.3634 16.1974 65.8449 16.2Z",
    fill: "url(#paint0_linear_526_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_526_2",
    x1: 121.126,
    y1: 16.2,
    x2: 121.126,
    y2: 226.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C21D05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29304D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.6c5d8140ddeb2c9eab3e51b40b7035b8.svg";
export { ForwardRef as ReactComponent };